import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Title } from '@/components/Typography';
import { useOWASContext } from '@/views/ListReport/Report/Owas/context';
import { CardScore } from '@/views/ListReport/Report/Owas/components/CardScore';
import { useGetOwasFrameResult } from '@/views/ListReport/Report/Owas/hooks/useGetOwasFrameResult';
import * as S from './styles';

interface ResultProps {
	frameId: string;
}

export function Result({ frameId }: Readonly<ResultProps>): JSX.Element {
	const { parameters, data } = useOWASContext();

	const { data: result } = useGetOwasFrameResult({
		organization_id: parameters?.organization_id!,
		company_id: parameters?.company_id!,
		file_id: parameters?.file_id!,
		report_id: data?.id ?? '',
		frame_id: frameId
	});

	return (
		<S.Container>
			<Col lg={8} xxl={10}>
				<Row justify="center" align="middle" style={{ height: '100%' }} gutter={[10, 0]}>
					<Col>
						<Title level={5} style={{ margin: 0 }}>
							{I18n.get('Code')}: {result?.code || 0}
						</Title>
					</Col>
				</Row>
			</Col>
			<Col span={1} style={{ height: '100%' }}>
				<S.DividerWrapper type="vertical" />
			</Col>
			<Col lg={15} xxl={13}>
				<Row justify="center" align="middle" style={{ height: '100%' }} gutter={[10, 0]}>
					<Col>
						<Title level={5} style={{ margin: 0 }}>
							{I18n.get('Overall risk of the task')}:
						</Title>
					</Col>
					<Col span={2}>
						<CardScore score={result?.score} />
					</Col>
				</Row>
			</Col>
		</S.Container>
	);
}
